export const VERIFIED_ORGANISATION_SEARCH_MAX_LENGTH = 255

// Search intent. The BE resolves the partner-configured allowlist category for the scope; the
// client only declares intent. The union case (browse/discovery) is the explicit
// `donation_or_volunteering` value, never a comma-combined list.
export const OrgSearchFor = {
  Donation: 'donation',
  Volunteering: 'volunteering',
  DonationOrVolunteering: 'donation_or_volunteering'
} as const

export type OrgSearchFor = typeof OrgSearchFor[keyof typeof OrgSearchFor]

export type OrgAllowlistScope = Exclude<OrgSearchFor, typeof OrgSearchFor.DonationOrVolunteering>

export type SearchVerifiedOrganisationQuery = {
  query?: string
  pageSize?: number
  countryCode?: string
  shortLanguage?: string
  activityTags?: string[]
  for?: OrgSearchFor
}

export type VerifiedOrganisationSearchResult = {
  organisationId: string
  countryCode: string
  description?: string
  logoUrl?: string | null
  name: string
  displayName?: string
  website?: string | null
  organisationIdInRegistry?: string | null
  address?: {
    line1: string | null
    line2: string | null
    city: string | null
    state: string | null
    postalCode: string | null
  }
  ab488Compliant?: boolean
  allowlistScopes?: OrgAllowlistScope[]
}
